export const postMessageToParent = ({type, content, sourceOrigin}) => {
  const message = {
    type: type,
    content: {
      status: content.status,
      data: content.data,
      cookie: content.cookie,
      message: content.message,
      notificationContent: content.notificationContent
    }
  };
  window.parent?.postMessage(message, sourceOrigin);
};

export const postMessageToOpener = ({type, content, sourceOrigin}) => {
  const message = {
    type: type,
    content: {
      status: content.status,
      data: content.data,
      message: content.message,
      notificationContent: content.notificationContent
    }
  };

  const opener = window.opener;

  if (!opener) {
    return;
  }

  const targets = [opener];
  try {
    for (let i = 0; i < opener.length; i++) {
      targets.push(opener[i]);
    }
  } catch (e) {
    // Cross-origin frame enumeration is blocked on this browser.
    // `targets` already holds `opener`, so the loop below is the fallback:
    // post to the opener only, i.e. current behaviour.
  }

  targets.forEach(target => {
    try {
      target.postMessage(message, sourceOrigin);
    } catch (e) {
      console.warn('postMessage failed targetOrigin: %s exceptionMessage: %s', sourceOrigin, e.message);
    }
  });
};